module.exports = __webpack_public_path__ + "img/68ne.a9ff0539.svg";